<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :pageSizeManual="pageSizeManual"
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('WarehouseName') },
            { title: $t('AutomationCode') },
            { title: $t('Applicant') },
            { title: $t('OrderNumber') },
            { title: $t('InventoryTransactionId') },
            { title: $t('CreateOn') },
            { title: $t('Action') }
          ]"
        >
          <template slot-scope="{ row, pagination }">
            <td style="width:15%">{{ row.storeInfoQuery.name }}</td>
            <td style="width:10%">
              {{ row.automationCode }}
            </td>
            <td style="width:15%">
              {{ row.inventoryRequesterQuery.name }}
            </td>
            <td width="13%">
              <span
                v-if="
                  row.contractId == null &&
                    row.draftOrderInfoQuery.basketId != null
                "
              >
                {{ "APO-" + row.draftOrderInfoQuery.basketId }}
              </span>
              <span
                v-if="
                  row.contractId == null &&
                    row.draftOrderInfoQuery.basketId == null
                "
              >
                -
              </span>
            </td>
            <td style="width:12%;direction: ltr;">
              {{ row.id }}
            </td>
            <td style="width:15%;direction: ltr;">
              {{ row.persianCreateOn }}
            </td>
            <td style="width:20%">
              <router-link
                :to="{
                  path: '/CheckOutForDraftOrder/Details/' + row.id,
                  query: {
                    type: 'forCreate',
                    numberRowsPerPage: pagination.pageSize,
                    tabIndex: tabIndex
                  }
                }"
              >
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="view-details"
                  v-has-permission="permission230"
                  >{{ $t("ViewDetails") }}</vs-button
                >
              </router-link>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}

.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "warehouseManagement_CheckOutTransactions_WithoutOrderCheckouts",

  components: {
    DataGrid
  },
  props: {
    tabIndex: { default: "" },
    numberRowsPerPage: {
      default: -1
    }
  },
  data() {
    return {
      permission230: "GetAllCheckOutForDraftOrderTransaction",
      gridSearchData: {
        checkOutStateQuery: "1"
      },
      pageSizeManual: 10,
      gridDataSource: { data: [] }
    };
  },
  mounted() {
    this.pageSizeManual = this.numberRowsPerPage ? this.numberRowsPerPage : -1;
    this.gridDataSource = {
      type: "app",
      service: "Sales/api/CheckOutForDraftOrderTransactionsQuery/state"
    };
    this.renderGrid();
  },
  methods: {
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 200);
    }
  }
};
</script>
